import axios from 'axios';
import ApiURLs from '@/ApiURLs';

export class ChildServiceGetters {
    getTestData() {
        return axios.get(ApiURLs.getSurvey);
    }

    getInitialData() {
        return axios.get(ApiURLs.getInitialData);
    }

    postEnrollmentForm(data: any) {
        return axios.post(ApiURLs.enrollChild, data);
    }

    getInvitationLink() {
        return axios.get(ApiURLs.getInvitationLink);
    }    

    getProviderInvitationLink(data: {
        loginPageUrl: any,
        appHomePageUrl: any,
        providerId: any
    }) {
        const loginPageUrl = data.loginPageUrl;
        const appHomePageUrl = data.appHomePageUrl;
        const providerId = data.providerId;

        return axios.get(ApiURLs.getProviderInvitationLink, {
            params: {
                loginPageUrl,
                appHomePageUrl,
                providerId
            }
        });
    }

    getChildren() {
        return axios.get(ApiURLs.getChildren);
    }

    getLanguages() {
        return axios.get(ApiURLs.getLanguages);
    }

    getChildrenVaccinationDates(childId: string) {
        return axios.get(ApiURLs.getChildrenVaccinationDates, { params: { childId } });
    }

    getVaccines() {
        return axios.get(ApiURLs.getVaccines);
    } 
    getChildInfo(childId:string) {
        return axios.get(ApiURLs.getChildInfo,{params:{childId}});
    } 
    
    getSchoolArrangement(childId:string) {
        return axios.get(ApiURLs.getSchoolArrangementInfo,{params:{childId}});
    } 
    getCustodyArrangement(childId: string) {
        return axios.get(ApiURLs.getCustodyArrangement, { params: { childId } });
    }

    getEmergencyContacts(childId: string) {
        return axios.get(ApiURLs.getEmergencyContacts, { params: { childId } })
    }

    getPickupPersons(childId: string) {
        return axios.get(ApiURLs.getPickupPersons, { params: { childId } })
    }
    getAllergens() {
        return axios.get(ApiURLs.getAllergens);
    }

    getChosenAllergens(childId: string) {
        return axios.get(ApiURLs.getChosenAllergens, {
            params: { childId }
        });
    }

    getAllergyInfo(childId: string) {
        return axios.get(ApiURLs.getAllergyInfo, {
            params: { childId }
        });
    } 

    getSkinProducts() {
        return axios.get(ApiURLs.getSkinProducts);
    }

    getChildSkinProducts(childId: string) {
        return axios.get(ApiURLs.getChildSkinProducts, {
            params: { childId }
        });
    }
 
    getCurrentViewedStep(childId:string) {
        return axios.get(ApiURLs.getCurrentViewedStep,{
            params:{childId}
        });
    }

    updateCurrentViewedStep(childId:string) {
        return axios.post(ApiURLs.updateCurrentViewedStep,{
            params:{childId}
        });
    } 
    getChildEnrollmentStep(childId: string) {
        return axios.get(ApiURLs.getChildEnrollmentStep, {
            params: { childId }
        });        
    }

    getChildFeedingArrangement(childId: string) {
        return axios.get(ApiURLs.getChildFeedingArrangement, { params: { childId } });
    }

    getChildPhysicalRequirements(childId: string) {
        return axios.get(ApiURLs.getChildPhysicalRequirements, { params: { childId } });
    }

    getChildSleepArrangement(childId: string) {
        return axios.get(ApiURLs.getChildSleepArrangement, { params: { childId } });
    }

    getAdditionalEmergencyInfo(childId: string) {
        return axios.get(ApiURLs.getAdditionalEmergencyInfo, { params: { childId } });
    }

    getAdditionalInfo(childId: string) {
        return axios.get(ApiURLs.getAdditionalInfo, { params: { childId } });
    }

    getHealthInformation() {
        return axios.get(ApiURLs.getHealthInformation);
    }

    populateHealthInformation(childId: string) {
        return axios.get(ApiURLs.populateHealthInformation, { params: { childId } })
    }
}

export default new ChildServiceGetters();